import type { AxiosRequestConfig } from 'axios';

import { Page } from '@/shared/api/pagination';
import type {
  CreateUser,
  UpdateUser,
  User,
  UserBrief,
  UserChangePasswordRequest,
  UserSetPasswordRequest,
} from '@/entities/user/user';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

const defaultOptions = {
  baseURL: '/api/auth/v4/',
};

type UsersPage<T> = Page<T> & { allow_ldaps: string[]; allow_idps: string[] };
export class UsersAPI {
  static getUsers(options?: AxiosRequestConfig) {
    return authInstance.get<UsersPage<User>>(`/users`, {
      ...defaultOptions,
      ...options,
    });
  }

  static getUser(userId: string, options?: AxiosRequestConfig) {
    return authInstance.get<User>(`/user/${userId}/map`, {
      ...defaultOptions,
      ...options,
    });
  }

  static getCurrentUser(options?: AxiosRequestConfig) {
    return authInstance.get<User>(`/user/map`, {
      ...defaultOptions,
      ...options,
    });
  }

  // static getAvatar(userId: string, options: AxiosRequestConfig = {}) {
  //   return authInstance.get(`/user/${userId}/avatar`, {
  //     ...options,
  //     responseType: 'arraybuffer',
  //   });
  // }

  // static uploadAvatar(
  //   formData: FormData,
  //   userId: string,
  //   options?: AxiosRequestConfig,
  // ) {
  //   return authInstance.put(`/user/${userId}/avatar`, formData, options);
  // }

  static createUser(user: CreateUser, options?: AxiosRequestConfig) {
    return authInstance.post<User>(`/user/map`, user, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateCurrentUser(user: UpdateUser, options?: AxiosRequestConfig) {
    return authInstance.put<User>(`/user/map`, user, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateUser(
    id: string,
    user: CreateUser,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put<User>(`/user/${id}/map`, user, {
      ...defaultOptions,
      ...options,
    });
  }

  static deleteUser(
    user_id: string,
    force?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.delete(`/user/${user_id}`, {
      ...defaultOptions,
      ...options,
      params: { force },
    });
  }

  static changePassword(
    payload: UserChangePasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put<UserBrief>(`/user/password`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static setPassword(
    id: string,
    payload: UserSetPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put<UserBrief>(`/user/${id}/password`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateExpiredPassword(
    user_id: string,
    payload: { old_password: string; new_password: string },
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put(`/user/${user_id}/reset_password`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static changeLanguage(language: string, options?: AxiosRequestConfig) {
    return authInstance.put(
      `/user/language`,
      { language },
      {
        ...defaultOptions,
        ...options,
      },
    );
  }
  static setStatus(
    id: string,
    status: string,
    force?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put(
      `/user/${id}/status`,
      { new_status: status },
      {
        ...defaultOptions,
        ...options,
        params: { force },
      },
    );
  }
  static getLanguages(options?: AxiosRequestConfig) {
    return authInstance.get<string[]>('/user/languages', {
      ...defaultOptions,
      ...options,
    });
  }

  //DEPRECATED

  // static async getUserAttribute(id: string, options: AxiosRequestConfig = {}) {
  //   return authInstance.get<UserAttributeBaseSchema>(
  //     `/users/attribute/${id}`,
  //     options,
  //   );
  // }

  // static async updateUserAttribute(
  //   id: string,
  //   payload: UserAttributeUpdateRequest,
  //   options: AxiosRequestConfig = {},
  // ) {
  //   return authInstance.put<UserAttributeBaseSchema>(
  //     `/users/attribute/${id}`,
  //     payload,
  //     options,
  //   );
  // }

  // static async createUserAttribute(
  //   payload: UserAttributeCreateRequest,
  //   options: AxiosRequestConfig = {},
  // ) {
  //   return authInstance.post<UserAttributeBaseSchema>(
  //     `/users/attribute`,
  //     payload,
  //     options,
  //   );
  // }

  // static deleteUserAttribute(id: string, options: AxiosRequestConfig = {}) {
  //   return authInstance.delete(`/users/attribute/${id}`, options);
  // }

  // //V4

  // static getAttributes(options?: AxiosRequestConfig) {
  //   return authInstance.get<Page<UserAttribute>>(`/attributes`, options);
  // }

  // static getAttribute(id: string, options?: AxiosRequestConfig) {
  //   return authInstance.get<UserAttribute>(`/attribute/${id}`, options);
  // }

  // static createAttribute(
  //   payload: UserAttributeCreate,
  //   options?: AxiosRequestConfig,
  // ) {
  //   return authInstance.post<UserAttribute>(`/attribute`, payload, options);
  // }

  // static updateAttribute(
  //   id: string,
  //   payload: UserAttribute,
  //   options?: AxiosRequestConfig,
  // ) {
  //   return authInstance.put<UserAttribute>(
  //     `/attribute/${id}`,
  //     payload,
  //     options,
  //   );
  // }
}